import { render, staticRenderFns } from "./_layout_default.vue?vue&type=template&id=057b09de&scoped=true&"
import script from "./_layout_default.vue?vue&type=script&lang=js&"
export * from "./_layout_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b09de",
  null
  
)

export default component.exports